import { trans } from "@mongez/localization";
import { ReactNode } from "react";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "~/design-system/components/ui/accordion";
import {
  FooterHours,
  FooterLink,
  FooterSectionContent,
} from "./FooterSectionContent";

type FooterAccordionItemProps = {
  value: string;
  titleKey: string;
  type: "pages" | "contact" | "openingHours" | "socialMedia";
  items: FooterLink[] | FooterHours[] | { label: ReactNode; value: string }[];
};

export function FooterAccordionItem({
  value,
  titleKey,
  type,
  items,
}: FooterAccordionItemProps) {
  return (
    <AccordionItem value={value} className="border-b">
      <AccordionTrigger className="text-primary-dark text-lg font-semibold hover:no-underline">
        {trans(titleKey)}
      </AccordionTrigger>
      <AccordionContent>
        <FooterSectionContent type={type} items={items} />
      </AccordionContent>
    </AccordionItem>
  );
}
